prismanoteApp.controller('retailerAutoCreatedPurchaseOrderModalController', ['$scope', '$uibModalInstance', 'message',
  function ($scope, $uibModalInstance, message) {
    $scope.message = message // Asking user to add purchase order or not

    $scope.AddPurchaseOrder = function (isWanToAddPurchaseOrder) {
      $uibModalInstance.close(isWanToAddPurchaseOrder)
    }
  }])
